import './pedina-podio.css';

/*
 * Il posto sul podio, una volta sola per tutta l'app.
 *
 * `MedalIcon` è disegnata per 48px: nastri e stella attorno a un disco che, reso
 * a 20-22, resta sui 13 e si perde — e non dice il numero. Qui il posto è un
 * pezzo del gioco: una pedina col numero dentro, che alla stessa larghezza si
 * legge e non fa perdere la posizione. La medaglia disegnata resta dov'è grande
 * abbastanza per leggersi, cioè il podio finale dell'arena (36/32px).
 *
 * Il markup stava copiato in TournamentStandings e ArenaStandings, con due modi
 * diversi di scegliere la tinta; le classifiche ne avrebbero fatti quattro.
 */

export type MedagliaPodio = 'gold' | 'silver' | 'bronze';

/**
 * Il colore segue il NUMERO che si mostra, non il merito di chi lo porta: come
 * la lista numera le parita' decide anche le tinte, e le due classifiche a turni
 * numerano in modo diverso. Il torneo tiene lo stesso posto a chi e' pari su
 * tutta la chiave sportiva (1, 2, 2: due argenti, nessun bronzo); l'arena mostra
 * il posto di merito (1, 1, 3: due ori, nessun argento). Oltre il terzo non c'e'
 * medaglia.
 */
export function medagliaDelPosto(rank: number): MedagliaPodio | null {
  if (rank === 1) return 'gold';
  if (rank === 2) return 'silver';
  if (rank === 3) return 'bronze';
  return null;
}

export interface PedinaPodioProps {
  rank: number;
  /** `data-testid` della pedina: ogni classifica ha il suo. */
  testId?: string;
}

/**
 * La pedina, o `null` fuori dal podio: il ripiego — il numero nudo — ha una
 * classe diversa in ogni lista (`tournament-standing-rank`, `arena-rank-number`,
 * `.col-rank`, `.mg-rank`), quindi resta a chi chiama.
 */
export function PedinaPodio({ rank, testId }: PedinaPodioProps) {
  const medaglia = medagliaDelPosto(rank);
  if (!medaglia) return null;
  return (
    <span className="pedina-podio" data-testid={testId} data-medal={medaglia}>
      {rank}
    </span>
  );
}

export default PedinaPodio;
